import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OrgLeavesService {
  public REST_API_SERVER:string = `${environment.REST_API_URL}/api/web/${environment.version}`;
  
  constructor(private http:HttpClient) { }

  public getOrganizationLeaves(filterParams:any={}):Observable<any>{
    return this.http.get(`${this.REST_API_SERVER}/organisationleaves`,{params:filterParams,observe:'response'});
  }

  public createOrganizationLeave(data:any):Observable<any>{
    return this.http.post(`${this.REST_API_SERVER}/organisationleaves/create`,data);
  }
}